import { FC, PropsWithChildren, useEffect } from 'react'
import { matchPath, useLocation } from 'react-router'

import { clearCurrentRegion, setCurrentRegion } from '@/modules/api/currentRegionRef'
import { RegionResponse } from '@/modules/api/openapi/models/RegionResponse'
import { useCurrentRegion } from '@/modules/urlRouting/hooks'
import { PARAMS } from '@/modules/urlRouting/paths'

/**
 * Keeps the non-React `currentRegionRef` (read by the legacy request helpers) in sync with the
 * regionId in the path. The region itself is owned by React Query (`useCurrentRegion`); this just
 * mirrors it into the transitional ref.
 */
const SyncRegionIdParam: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation()
  const matchObject = matchPath<string>(`/:${PARAMS.REGION_ID}/*`, location.pathname)
  const regionIdParam = matchObject?.params?.regionId
  const { data: region } = useCurrentRegion<RegionResponse>()

  useEffect(() => {
    if (regionIdParam) {
      setCurrentRegion(region)
    }

    return () => {
      clearCurrentRegion()
    }
  }, [regionIdParam, region])

  return children
}

export default SyncRegionIdParam
